<template>
    <div>
        <div class="suc-txt">交易成功！3500平台币已到达您的账户</div>
        <div class="suc-back" @click="gofinance">返回查看</div>
    </div>
</template>
<script>
    export default{
        data(){
            return{

            }
        },
        methods:{
            gofinance(){
                this.$router.push({path:'/index/finance/index'})
            }
        }
    }
</script>
<style lang="less" scoped>
.suc-txt{
    color: #666;
    font-size: 16px;
}
    .suc-back{
        width: 140px;
        height: 40px;
        background: #495fcd;
        color: #fff;
        text-align: center;
        line-height: 40px;
        border-radius: 20px;
    }
</style>



// WEBPACK FOOTER //
// chargeSuc.vue?722fb5f8